/* eslint-disable */

import type { Abi } from "viem"

import { erc20Abi } from "@/domains/abis"
import { determineApprovalAmount } from "@/domains/library"

import type { ApproveTokenAllowanceParams, TransactionReturnType } from "../types"
import { simulatedTransaction } from "../simulated-transaction"

export const approveOwnerSpenderAllowance = async ({
  account,
  chainId,
  config,
  contractAddress,
  spenderAddress,
  spenderAmount,
  approvalMode,
  contractRiskLevel,
  receiptWait,
}: ApproveTokenAllowanceParams): Promise<TransactionReturnType> => {
  try {
    const actualAmountToApprove = determineApprovalAmount(spenderAmount, approvalMode, contractRiskLevel)

    // console.log("approveOwnerSpenderAllowance", approvalMode, contractRiskLevel, actualAmountToApprove)

    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: erc20Abi as Abi,
        account,
        address: contractAddress,
        args: [spenderAddress, actualAmountToApprove],
        chainId,
        functionName: "approve",
      },
      receiptWait,
    })

    return result
  } catch (error: any) {
    console.error("approveOwnerSpenderAllowance", error)
    return { success: false, error: error.message, code: error.code }
  }
}
